export const formatSizeValue = (value) => {
    if (value === undefined)
        return undefined;
    return typeof value === 'number' ? `${value}px` : `${value}`;
};
export const getSizeValues = (props) => {
    return Object.fromEntries(Object.entries(props).map(([key, value]) => [key, formatSizeValue(value)]));
};
//# sourceMappingURL=formatSizeValues.js.map